import * as yup from 'yup';

export const MAX_COST_CENTER_LENGTH = 256;
export const MAX_DESCRIPTION_LENGTH = 256;
export const MAX_BUSINESS_VALUE_LENGTH = 256;

export const requestAccessSchema: yup.AnyObjectSchema = yup
  .object({
    cost_center: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .max(MAX_COST_CENTER_LENGTH, `Cost center should contain up to ${MAX_COST_CENTER_LENGTH} characters`)
      .required('Cost center is a required field'),
    use_case_description: yup
      .string()
      .max(MAX_DESCRIPTION_LENGTH, `Description should contain up to ${MAX_DESCRIPTION_LENGTH} characters`)
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .required('Description is a required field'),
    primary_secondary_use_case: yup
      .array()
      .of(yup.string().required())
      .min(1, 'Use case is a required field')
      .required('Use case is a required field'),
    business_value: yup
      .string()
      .max(MAX_BUSINESS_VALUE_LENGTH, `Business value should contain up to ${MAX_BUSINESS_VALUE_LENGTH} characters`)
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .required('Business value is a required field'),
  })
  .required();
